import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

export default class VideoPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
    };
  }

  componentWillMount() {}

  handleOnReady = () => {
    this.setState({ ready: true });
  };

  render() {
    const { url, playing, swatch, loop, muted } = this.props;
    return (
      <div className={this.props.className}>
        <ReactPlayerContainer customRatio={this.props.customRatio}>
          <StyledReactPlayer
            url={url}
            width="100%"
            height="100%"
            playing={playing}
            loop={loop}
            muted={muted}
            onReady={this.handleOnReady}
            style={{ opacity: this.state.ready ? '1' : '0' }}
          />
          <SwatchImg src={swatch} alt="" />
        </ReactPlayerContainer>
      </div>
    );
  }
}

const ReactPlayerContainer = styled.div`
  padding: ${props => props.customRatio || '56.25%'} 0 0 0;
  position: relative;
  overflow: hidden;
  /* Fix weird Safari bug breaking rounded corners */
  mask-image: -webkit-radial-gradient(white, black);
`;

const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  z-index: 1;
  transition: opacity ease-in 200ms;
`;

const SwatchImg = styled.img`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  filter: blur(5px);
  height: 100%;
  object-fit: contain;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.js